import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { STATIC_VEHICLE_DATA } from '../schemas/StaticVehicleSchema';
import { StaticVehicleData } from '../types';

type UseStaticVehicleData = (vehicleStoreId: string) => string | undefined;

interface QueryResult {
  getStaticVehicleById: StaticVehicleData;
}

const useStaticVehicleData: UseStaticVehicleData = (vehicleStoreId) => {
  const [getStaticVehicle, { data: staticVehicle }] = useLazyQuery<QueryResult>(
    STATIC_VEHICLE_DATA,
    {
      errorPolicy: 'all',
    },
  );

  useEffect(() => {
    if (!vehicleStoreId) return;

    getStaticVehicle({
      variables: {
        vehicleStoreId,
      },
    });
  }, [vehicleStoreId, getStaticVehicle]);

  return staticVehicle?.getStaticVehicleById?.rapid_name;
};

export default useStaticVehicleData;
